/**
 * @desc 获取用户信息
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/sysUser/info`, {
      method: "GET",

      ...options,
    }),
  );
}
